import { render, staticRenderFns } from "./productPriceSerach.vue?vue&type=template&id=d1f2c42a&scoped=true&"
import script from "./productPriceSerach.vue?vue&type=script&lang=js&"
export * from "./productPriceSerach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f2c42a",
  null
  
)

export default component.exports